import { defineMessages } from 'react-intl';

export default defineMessages({
  resetTours: {
    id: 'cboard.components.ResetToursItem.resetTours',
    defaultMessage: 'Reset all help tours'
  },
  resetToursSecondary: {
    id: 'cboard.components.ResetToursItem.resetToursSecondary',
    defaultMessage: 'Enable all the help tours across Cboard again'
  },
  confirmDialog: {
    id: 'cboard.components.ResetToursItem.confirmDialog',
    defaultMessage: 'Are you sure you want to enable all help tours again?'
  },
  ok: {
    id: 'cboard.components.ResetToursItem.ok',
    defaultMessage: 'OK'
  },
  cancel: {
    id: 'cboard.components.ResetToursItem.cancel',
    defaultMessage: 'Cancel'
  }
});
